import {fabric} from 'fabric';
import {FABRIC_GROUP_END, FABRIC_GROUP_START} from '~/common/canvas/constants';
import * as colors from '~libSass/base/_exports.sass';

// Defining custom fabric element type TextBorder
fabric.TextBorder = fabric.util.createClass(fabric.Rect, {
  isError: false,
  initialize(options) {
    this.callSuper('initialize', options);
  },
});

fabric.TextBorder.fromObject = (object, callback) => {
  const textBorder = new fabric.TextBorder(object);
  if (typeof callback === 'function') {
    callback(textBorder);
  }
  return textBorder;
};

// Hide border for target textbox
export const canvasHideTextBorder = (selectedTextbox, canvas) => {
  const canvasObjs = canvas?.getObjects();

  if (selectedTextbox?.text && canvasObjs.length > 0) {
    const textBorder = canvasObjs?.find(
      (obj) => obj.identifier === `border-${selectedTextbox.identifier}`
    );
    const textEditIcon = canvasObjs?.find(
      (obj) => obj.identifier === `icon-${selectedTextbox.identifier}`
    );
    textBorder?.set({stroke: 'transparent'});
    textEditIcon?.set({top: 9999});
    if (canvas) canvas.renderAll();
  }
};

// Hide edit icon for target textbox
export const canvasHideEditIcon = (selectedTextbox, canvas) => {
  const canvasObjs = canvas?.getObjects();

  if (selectedTextbox?.text && canvasObjs.length > 0) {
    const textEditIcon = canvasObjs.find(
      (obj) => obj.identifier === `icon-${selectedTextbox.identifier}`
    );
    textEditIcon?.set({top: 9999});
    if (canvas) canvas.renderAll();
  }
};

// Hide edit icon and border for all textboxes
export const canvasHideTextBordersAndIcons = (canvas) => {
  const canvasObjs = canvas?.getObjects();

  canvasObjs
    ?.filter((obj) => obj.type === 'textbox')
    .forEach((textbox) => {
      if (!textbox?.text) return;
      const textBorder = canvasObjs?.find(
        (obj) => obj.identifier === `border-${textbox.identifier}`
      );
      const textEditIcon = canvasObjs?.find(
        (obj) => obj.identifier === `icon-${textbox.identifier}`
      );
      textBorder?.set({stroke: 'transparent'});
      textEditIcon?.set({top: 9999});
      if (canvas) canvas.renderAll();
    });
};

// Remove edit icon for target textbox
export const canvasRemoveEditIcon = (selectedTextbox, canvas) => {
  const canvasObjs = canvas?.getObjects();

  if (selectedTextbox?.text && canvasObjs.length > 0) {
    const textEditIcon = canvasObjs.find(
      (obj) => obj.identifier === `icon-${selectedTextbox.identifier}`
    );

    if (textEditIcon) canvas.remove(textEditIcon);
    if (canvas) canvas.renderAll();
  }
};

const positionIcon = (textbox) => textbox.left + (textbox.width * textbox.scaleX - 38);

// Show borders and edit icons for textboxes
export const canvasShowTextBordersAndIcons = (canvas) => {
  const canvasObjs = canvas?.getObjects();

  canvasObjs
    ?.filter((obj) => obj.type === 'textbox')
    .forEach((textbox) => {
      const textBorder = canvasObjs.find(
        (obj) => obj.identifier === `border-${textbox.identifier}`
      );
      const iconLeft = textbox.angle === 0 ? positionIcon(textbox) : 9999;
      const editIcon = canvasObjs.find((obj) => obj.identifier === `icon-${textbox.identifier}`);

      textBorder?.set({
        stroke: colors.tanzanite,
        top: textbox.top,
        right: textbox.right,
        bottom: textbox.bottom,
        left: textbox.left,
        height: textbox.height,
        width: textbox.width,
        angle: textbox.angle,
        scaleX: textbox.scaleX,
        scaleY: textbox.scaleY,
      });
      editIcon?.set({
        top: textbox.top + 3,
        left: iconLeft,
      });
      if (canvas) canvas.renderAll();
    });
};

export const canvasAddTextBorderAndIcon = (
  textbox,
  canvas,
  id,
  objects = window.fabricTemplate?.editable_art?.default?.objects
) =>
  new Promise((resolve, reject) => {
    if (!textbox.height || !textbox.text) {
      resolve();
      return;
    }

    textbox?.set({
      identifier: `textbox-${id}`,
    });

    const imgElement = new Image();
    imgElement.src = '/assets/images/canvas-edit-icon.png';
    const iconLeft = textbox.angle === 0 ? positionIcon(textbox) : 9999;
    const activeObj = canvas.getActiveObject();
    const isActive = !!(textbox.identifier === activeObj?.identifier);

    imgElement.onload = () => {
      const fabricBorder = new fabric.TextBorder({
        left: textbox.left,
        top: textbox.top,
        width: textbox.width,
        height: textbox.height, // Setting a minimum height equal to the height of the edit icon
        fill: 'transparent',
        stroke: isActive ? 'transparent' : colors.tanzanite,
        strokeDashArray: [18, 18],
        strokeWidth: 3,
        selectable: false,
        identifier: `border-${textbox.identifier}`,
        angle: textbox.angle,
        type: 'textBorder',
        scaleX: textbox.scaleX,
        scaleY: textbox.scaleY,
      });

      const fabricImage = new fabric.Image(imgElement, {
        // Position set to top right corner
        left: iconLeft,
        top: isActive ? 9999 : textbox.top + 3,
        scaleX: 0.22,
        scaleY: 0.22,
        selectable: false,
        identifier: `icon-${textbox.identifier}`,
      });

      canvas.add(fabricBorder);

      // Bring all textboxes to the front
      canvas.getObjects().forEach((obj) => {
        if (obj.type === 'textbox') canvas.bringToFront(obj);
      });

      // If the text, left and top properties all match, return false; otherwise return true
      const textboxModified = () => {
        const matchingObject = objects.find((obj) => obj.text === textbox.text);
        return !(
          matchingObject &&
          matchingObject.left === textbox.left &&
          matchingObject.top === textbox.top
        );
      };

      if (!textboxModified()) {
        canvas.add(fabricImage);
        canvas.bringToFront(fabricImage);
      }
      if (canvas) canvas.renderAll();
      resolve();
    };

    imgElement.onerror = () => {
      reject(new Error('Image loading failed'));
    };
  });

// Create dashed borders and edit icons for the textboxes showing they're editable
export const canvasAddTextBordersAndIcons = (
  canvas,
  originalFabricArt = window.fabricTemplate?.editable_art?.default
) =>
  new Promise((resolve, reject) => {
    try {
      canvas?.fire(FABRIC_GROUP_START);

      const textboxes = canvas?.getObjects().filter((object) => object.type === 'textbox');
      const promises = textboxes.map((textbox, index) =>
        canvasAddTextBorderAndIcon(textbox, canvas, index + 1, originalFabricArt.objects)
      );

      Promise.all(promises)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => canvas?.fire(FABRIC_GROUP_END));
    } catch (error) {
      reject(error);
    }
  });

// Remove text borders and edit icons before navigating to step 2
export const canvasRemoveTextBordersAndIcons = async (canvas) => {
  const matchingObjects = canvas?.getObjects().filter(
    (object) =>
      object.identifier?.includes('icon-') ||
      object.identifier?.includes('border-') ||
      object.src?.includes('edit-icon') || // Redundancy
      object.type === 'textBorder' // Redundancy
  );

  canvas?.fire(FABRIC_GROUP_START);
  const totalMatchingObjects = matchingObjects?.length;

  for (let i = 0; i < totalMatchingObjects; i++) {
    const textOrIcon = matchingObjects[i];
    canvas.remove(textOrIcon);
    if (i === totalMatchingObjects - 1) {
      canvas.fire(FABRIC_GROUP_END);
      return true; // Allow navigation when the last matching object is removed
    }
  }
  canvas?.fire(FABRIC_GROUP_END);
  return true; // Allow navigation if there are no matching objects
};
